import type { RouteRecordRaw } from 'vue-router';
export const claimsRoutes: RouteRecordRaw[] = [
  {
    path: 'claims/customer-claims',
    name: 'customer-claims',
    component: () => import('../pages/claims/CustomerClaimsPage.vue'),
    meta: { requiresModule: 'claims' },
  },
];
